/**
 * Product gallery on phones.
 * - The swipe row takes the height of the photo on screen, so a short photo doesn't
 *   leave a gap above the product info. The height only changes once a swipe has
 *   settled, never mid-gesture, so the page doesn't shift under the shopper's finger.
 * - Touch: up/down swipes on the photos always scroll the page; sideways swipes use
 *   the phone's native smooth scrolling with snap.
 */
const gallery = document.querySelector('[data-product-gallery]');
if (gallery) {
  const mq = window.matchMedia('(max-width: 767.98px)');
  const slides = () => [...gallery.querySelectorAll('[data-gallery-slide]')];
  let frame = 0;
  let settleTimer = 0;
  let touching = false;

  const fit = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!mq.matches) { gallery.style.height = ''; return; }
      const list = slides();
      if (!list.length) return;
      const index = Math.min(list.length - 1, Math.max(0, Math.round(Math.abs(gallery.scrollLeft) / gallery.clientWidth)));
      gallery.style.height = `${list[index].offsetHeight}px`;
    });
  };
  // Wait until the row stops moving (scrollend, or a short pause where scrollend isn't supported).
  const fitWhenSettled = () => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(() => { if (!touching) fit(); }, 140);
  };

  // Photo counter ("2 / 6") in the bottom right, updated live while swiping.
  const counter = document.querySelector('[data-gallery-counter] [data-gallery-current]');
  const updateCounter = () => {
    if (!counter) return;
    const total = slides().length;
    const index = Math.min(total - 1, Math.max(0, Math.round(Math.abs(gallery.scrollLeft) / (gallery.clientWidth || 1))));
    const value = String(index + 1);
    if (counter.textContent !== value) counter.textContent = value;
  };
  gallery.addEventListener('scroll', updateCounter, { passive: true });
  updateCounter();

  gallery.addEventListener('scroll', fitWhenSettled, { passive: true });
  gallery.addEventListener('scrollend', () => { if (!touching) fit(); }, { passive: true });
  mq.addEventListener('change', fit);
  new ResizeObserver(fitWhenSettled).observe(gallery);
  slides().forEach((s) => new ResizeObserver(fitWhenSettled).observe(s));
  fit();

  // Touch: native swiping between photos (smooth, with snap). The row is locked vertically
  // (overflow-y hidden), so up/down swipes always scroll the page and never move the photos.
  // While a finger is down the row's height stays fixed; it adjusts once the swipe settles.
  const lockVertical = () => { gallery.style.overflowY = mq.matches ? 'hidden' : ''; };
  lockVertical();
  mq.addEventListener('change', lockVertical);
  gallery.addEventListener('touchstart', () => { touching = true; }, { passive: true });
  const release = () => { touching = false; fitWhenSettled(); };
  gallery.addEventListener('touchend', release, { passive: true });
  gallery.addEventListener('touchcancel', release, { passive: true });
}
